import { useMemo } from 'react'
import { useTheme } from '../../../src/theme/useTheme'
import { UnderlineTabBar, type UnderlineTabDef } from '../../ui/UnderlineTabBar'
import { inviteModalTabsStyles as styles } from './InviteModalTabs.styles'
import type { InviteTab } from '../../../src/friends/types/inviteModal.types'

interface InviteModalTabsProps {
  activeTab: InviteTab
  onTabChange: (tab: InviteTab) => void
  testID?: string
}

export function InviteModalTabs({ activeTab, onTabChange, testID }: InviteModalTabsProps) {
  const theme = useTheme()

  const tabs = useMemo<ReadonlyArray<UnderlineTabDef<InviteTab>>>(
    () => [
      { key: 'manual', label: 'Manual Email' },
      { key: 'link', label: 'Invite Link' },
    ],
    []
  )

  return (
    <UnderlineTabBar
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
      activeTextColor={theme.primary}
      inactiveTextColor={theme.gray[600]}
      underlineColor={theme.primary}
      bottomBorderColor={theme.gray[300]}
      layout="equal"
      labelFontSize={16}
      tabPaddingVertical={12}
      style={styles.tabBar}
      containerTestID={testID ?? 'invite-modal-tabs'}
    />
  )
}
